import { stringify } from "qs";

export const paramsSerializer = (params: Record<string, unknown>): string => {
  const objectEntries = Object.entries(params).reduce((result: Record<string, string>, [key, value]) => {
    result[key] = JSON.stringify(value);
    return result;
  }, {});
  return stringify(objectEntries);
};
